export default {
  specification: 'Spezifikation',
};
